import script from './basic-time-spinner.vue_vue_type_script_lang.mjs';
export { default } from './basic-time-spinner.vue_vue_type_script_lang.mjs';
import { render } from './basic-time-spinner.vue_vue_type_template_id_4fb3c576_lang.mjs';

script.render = render;
script.__file = "packages/components/time-picker/src/time-picker-com/basic-time-spinner.vue";
//# sourceMappingURL=basic-time-spinner.mjs.map
